var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-primary open-question-btn-open-question",class:_vm.extraClasses,on:{"click":function($event){$event.preventDefault();return _vm.openQuestion.apply(null, arguments)}}},[_vm._v(" 查看原题 ")])}
var staticRenderFns = []

export { render, staticRenderFns }